import { Outlet, Route, Routes } from 'react-router-dom';

import DashboardTopLayout from '@/components/layouts/dashboard-top/dashboard-top-layout';
import NoMatch from '@/components/no-match';
import ApplicationProvider from '@/components/providers/application/application-provider';
import ClaimComponent from '@/components/providers/auth/claim-provider';
import { AuthRequired } from '@/components/providers/auth/guards';
import { StationContextProvider } from '@/components/providers/station/context';
import { ConfigureMap } from '@/pages/configure-map/configure-map-page';
import { ConfigurePlanStack } from '@/pages/configure-plan-stack/configure-plan-stack-page';
import { ConfigurePlan } from '@/pages/configure-plan/configure-plan-page';
import { SimulationDetailPage } from '@/pages/simulation/simulation-detail-page';
import { SimulationsPage } from '@/pages/simulations/simulations-page';

function WrapperDashboard() {
  return (
    <ClaimComponent>
      <StationContextProvider>
        <ApplicationProvider>
          <DashboardTopLayout>
            <Outlet />
          </DashboardTopLayout>
        </ApplicationProvider>
      </StationContextProvider>
    </ClaimComponent>
  );
}

export function RouteManager() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthRequired>
            <WrapperDashboard />
          </AuthRequired>
        }
      >
        <Route path="/" element={<SimulationsPage />} />
        <Route path="/simulation/:id" element={<SimulationDetailPage />} />
        <Route path="/configure-plan" element={<ConfigurePlan />} />
        <Route path="/configure-plan-stack" element={<ConfigurePlanStack />} />
        <Route path="/settings" element={<ConfigureMap />} />
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  );
}
